// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./operatorApi";

export let rootOprApi = new Api();
